import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";
import { BiEdit } from "react-icons/bi";
import videostyle from "./video.module.css";
import ModalComp from "../popUp/ModalComp";
import axios from "axios";

const apiUrl = process.env.REACT_APP_URL;

// Video component to display the user's video URL, receiving the data from ProfilePage
const VideoComp = ({
  video_url,
  username,
  handleUpdateProfileData,
  isEditable,
}) => {
  const [error, setError] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [videoId, setVideoId] = useState("");
  const [editedVideoUrl, setEditedVideoUrl] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // Set the video URL when the component mounts
  useEffect(() => {
    if (video_url) {
      setVideoUrl(video_url);
    }
  }, [video_url]);

  // Handle the error when the video fails to load
  const handleError = (e) => {
    setError(true);
  };

  // Set the error to false when the video is ready to play
  const handleReady = () => {
    setError(false);
  };

  // Open the modal with the current video URL
  const handleEditVideoUrl = () => {
    setEditedVideoUrl(videoUrl); // Set the edited video URL to the current video URL
    setModalOpen(true);
  };

  // Close the modal
  const handleCloseModal = () => {
    setModalOpen(false);
  };

  // Update the video URL in the database
  const handleConfirmEdit = async () => {
    const baseYouTubeUrl = "https://www.youtube.com/watch?v=";
    const fullVideoUrl = baseYouTubeUrl + videoId;

    if (!videoId || videoId.length < 11) {
      // Ensure videoId has valid length (YouTube video IDs are 11 characters long)
      setErrorMessage(
        "Invalid video ID. Please provide a valid YouTube video ID."
      );
      return;
    }

    try {
      const response = await axios.put(
        `${apiUrl}/users/update_video/${username}`,
        { videoLink: fullVideoUrl },
        { withCredentials: true }
      );

      if (response.status === 200 && response.data.success) {
        handleUpdateProfileData({ video_link: fullVideoUrl });
        setVideoUrl(fullVideoUrl);
        setError(false);
        setErrorMessage("");
        handleCloseModal();
      } else {
        console.error("Failed to update video URL. Please try again.");
      }
    } catch (error) {
      console.error("Error updating video URL:", error);
    }
  };

  return (
    <div className={videostyle.videomain}>
      {videoUrl ? (
        error ? (
          <>
            <p>Failed to load video. Please try again later.</p>
            {isEditable && (
              <button
                className={videostyle.emptyURLbutton}
                onClick={handleEditVideoUrl}
              >
                Add Video URL
              </button>
            )}
          </>
        ) : (
          <div className={videostyle.videoWrapper}>
            <ReactPlayer
              url={videoUrl}
              className={videostyle.reactplayer}
              controls={true}
              width="100%"
              height="100%"
              onError={handleError}
              onReady={handleReady}
            />
            {isEditable && (
              <BiEdit
                className={videostyle.editIcon}
                onClick={handleEditVideoUrl}
              />
            )}
          </div>
        )
      ) : (
        isEditable && (
          <button
            className={videostyle.emptyURLbutton}
            onClick={handleEditVideoUrl}
          >
            Add Video URL
          </button>
        )
      )}
      {/* ModalComp to edit the video URL */}
      <ModalComp isOpen={isModalOpen} onClose={handleCloseModal}>
        <h2>Edit Video URL</h2>
        <div className={videostyle.urlInput}>
          <label>https://www.youtube.com/watch?v=</label>
          <input
            type="text"
            value={videoId}
            onChange={(e) => setVideoId(e.target.value)}
            placeholder="Enter video ID"
          />
        </div>
        {errorMessage && (
          <p className={videostyle.errorMessage}>{errorMessage}</p>
        )}
        <div className={videostyle.buttons}>
          <button className={videostyle.button} onClick={handleConfirmEdit}>
            Confirm
          </button>
          <button className={videostyle.button} onClick={handleCloseModal}>
            Cancel
          </button>
        </div>
      </ModalComp>
    </div>
  );
};

export default VideoComp;
